<hr class="m-0 d-md-none" />
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <ng-content></ng-content>
  </ol>
</nav>
<hr class="mt-0" />
